import { render, staticRenderFns } from "./Fashion.vue?vue&type=template&id=88b0ae26&scoped=true"
import script from "./Fashion.vue?vue&type=script&lang=js"
export * from "./Fashion.vue?vue&type=script&lang=js"
import style0 from "./Fashion.vue?vue&type=style&index=0&id=88b0ae26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b0ae26",
  null
  
)

export default component.exports